import { Box } from "@mui/joy";
import DarkInput from "../../../common/DarkInput";
import DarkCheckbox from "../../../common/DarkCheckbox";
import CommonModal from "../../../common/CommonModal";
import PermissionsPicker from "./PermissionsPicker";

type RoleEditModalProps = {
  open: boolean;
  onClose: () => void;
  roleName: string;
  onRoleNameChange: (value: string) => void;
  isEmployee: boolean;
  onIsEmployeeChange: (value: boolean) => void;
  selectedPerms: string[];
  onSelectedPermsChange: (perms: string[]) => void;
  allPermissions: string[];
  permsLoading: boolean;
  onSubmit: () => void;
  canEdit?: boolean;
};

export default function RoleEditModal(props: RoleEditModalProps) {
  const {
    open,
    onClose,
    roleName,
    onRoleNameChange,
    isEmployee,
    onIsEmployeeChange,
    selectedPerms,
    onSelectedPermsChange,
    allPermissions,
    permsLoading,
    onSubmit,
    canEdit = true,
  } = props;
  return (
    <CommonModal
      open={open}
      onClose={onClose}
      title="Éditer le rôle"
      size="xl"
      fitContentHeight
      onConfirm={onSubmit}
      confirmLabel="Enregistrer"
      submitDisabled={!canEdit || !roleName.trim()}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          flex: 1,
          minHeight: 0,
          width: "100%",
          gap: { xs: 1.25, sm: 1.5 },
        }}
      >
        <Box sx={{ display: "flex", flexDirection: "column", gap: 1, flexShrink: 0 }}>
          <DarkInput
            placeholder="Nom du rôle"
            value={roleName}
            onChange={(e) => onRoleNameChange(e.target.value)}
            size="sm"
            disabled={!canEdit}
          />
          <DarkCheckbox
            label="Salarié"
            checked={isEmployee}
            onChange={(e) => onIsEmployeeChange(e.target.checked)}
            disabled={!canEdit}
          />
        </Box>
        <PermissionsPicker
          allPermissions={allPermissions}
          selectedPerms={selectedPerms}
          onChange={onSelectedPermsChange}
          loading={permsLoading}
          disabled={!canEdit}
          fillHeight
        />
      </Box>
    </CommonModal>
  );
}
